<script>

export default {

    name: 'OverviewEventHandler',

    props: ['prefix', 'action-mode'],

    data() {
        return {
            filterSection: null,
            sortingSection: null,
            mobileButtonReturnToResults: null,
        }
    },

    created() {
        this.filterSection = document.querySelector('.filter-section');
        this.sortingSection = document.querySelector('.mobile-sorting');
        this.mobileButtonReturnToResults = document.querySelector('.mobile-return-to-results');
    },

    mounted() {

        this.Bus.on('toggle-mobile-filters', () => {

            this.filterSection.classList.toggle('active');
            this.Bus.emit('dock-header');

            if (this.filterSection.classList.contains('active')) {
                this.Bus.emit('set-popup-active-class');
                this.Bus.emit('hide-mobile-sorting');
            } else {
                this.Bus.emit('set-popup-inactive-class');
                this.disableMobileReturnButton();
            }
        });

        this.Bus.on('hide-mobile-filters', () => {
            this.filterSection.classList.remove('active');
            this.disableMobileReturnButton();

            this.Bus.emit('set-popup-inactive-class');
        });

        this.Bus.on('show-mobile-return-button', () => {
            this.enableMobileReturnButton();
        });

        this.Bus.on('hide-mobile-return-button', () => {
            this.disableMobileReturnButton();
        });

        this.Bus.on('stop-loading', () => {
            if (this.filterSection.classList.contains('active')) {
                this.enableMobileReturnButton();
            }
        });

        this.Bus.on('close-primary-filters', () => {
            this.filterSection.classList.remove('active');
            this.disableMobileReturnButton();
        });

        this.Bus.on('favourite-house-set', (data) => {

            const houseCode = data.houseCode;
            const targetHeartActive = document.querySelector('.fav-heart-active[data-object-reference="' + houseCode + '"]');
            const targetHeartInactive = document.querySelector('.fav-heart-inactive[data-object-reference="' + houseCode + '"]');

            if (targetHeartActive && ! data.isSet) {
                targetHeartActive.classList.remove('fav-heart-active');
                targetHeartActive.classList.add('fav-heart-inactive');
            } else if (targetHeartInactive && data.isSet) {
                targetHeartInactive.classList.remove('fav-heart-inactive');
                targetHeartInactive.classList.add('fav-heart-active');
            }
        });

        this.Bus.on('toggle-alternative-result', (target) => {

            const parentElement = target.parentElement;
            const alternativeResultsElement = parentElement.querySelector('.alternative-results');

            const contentHeight = alternativeResultsElement.scrollHeight;

            if (parentElement.classList.contains('active')) {
                alternativeResultsElement.style.maxHeight = '0px';
                parentElement.classList.remove('active');

            } else {
                alternativeResultsElement.style.maxHeight = contentHeight + 'px';
                parentElement.classList.add('active');
            }
        });
    },

    methods: {
        enableMobileReturnButton() {
            this.mobileButtonReturnToResults.classList.add('active');
        },

        disableMobileReturnButton() {
            this.mobileButtonReturnToResults.classList.remove('active');
        },

    },

    render() {}
}

</script>

